type Props = {
  width?: number;
  height?: number;
  fill?: string;
}

const PhoneIcon = ({
  width = 12,
  height = 12,
  fill
}: Props) => {
  return (
    <svg width={width} height={height} viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="3.5" y="1" width="5" height="10" rx="1.5" stroke="#5D6E69" />
      <path d="M5 2.25H7" stroke="#5D6E69" strokeLinecap="round" />
      <path d="M5.25 9.75H6.75" stroke="#5D6E69" strokeLinecap="round" />
    </svg>
  )
}

export default PhoneIcon;